import { format } from "date-fns";
import { fmtTime, isOvernight, ymd } from "@/lib/dates";

const PrintShift = ({ s, type }) => (
  <div className="print-shift" style={{ borderLeftColor: type?.colour || "#94a3b8" }}>
    <b>{fmtTime(s.start)}–{fmtTime(s.end)}{isOvernight(s) ? " +1" : ""}</b> {type?.name || "Shift"}{type?.is_sleepover ? " (sleep)" : ""}
  </div>
);

const Cell = ({ items, types, off }) => (
  <td className={off ? "print-off" : ""}>
    {off && <div className="print-off-tag">OFF</div>}
    {items.map((s) => <PrintShift key={s.id} s={s} type={types[s.shift_type_id]} />)}
  </td>
);

const StaffLabel = ({ row, hours }) => (
  <>
    <div className="print-name">{row.name}</div>
    {row.id ? <div className="print-sub">{hours.toFixed(1)}h</div> : <div className="print-sub">Unassigned</div>}
  </>
);

const DayLabel = ({ d }) => <><div className="print-sub">{format(d, "EEE")}</div><div className="print-name">{format(d, "d MMM")}</div></>;

export const RotaPrintTable = ({ layout, days, rows, shifts, types, isOff }) => {
  const at = (row, d) => shifts.filter((s) => (s.staff_id || null) === row.id && s.start.slice(0, 10) === ymd(d));
  const hours = (sid) => shifts.filter((s) => s.staff_id === sid).reduce((a, s) => a + s.paid_hours, 0);
  const staffRows = layout !== "staff_cols";
  const dense = (staffRows ? days.length : rows.length) > 8;
  return (
    <table className={`print-only rota-print-table ${dense ? "dense" : ""}`} data-testid="rota-print-table">
      <thead>
        <tr>
          <th>{staffRows ? "Team" : "Date"}</th>
          {staffRows ? days.map((d) => <th key={ymd(d)}><DayLabel d={d} /></th>) : rows.map((r) => <th key={r.id || "open"}><StaffLabel row={r} hours={hours(r.id)} /></th>)}
        </tr>
      </thead>
      <tbody>
        {staffRows
          ? rows.map((r) => (
            <tr key={r.id || "open"}>
              <th><StaffLabel row={r} hours={hours(r.id)} /></th>
              {days.map((d) => <Cell key={ymd(d)} items={at(r, d)} types={types} off={r.id && isOff(r.id, d)} />)}
            </tr>
          ))
          : days.map((d) => (
            <tr key={ymd(d)} className={[0, 6].includes(d.getDay()) ? "weekend" : ""}>
              <th><DayLabel d={d} /></th>
              {rows.map((r) => <Cell key={r.id || "open"} items={at(r, d)} types={types} off={r.id && isOff(r.id, d)} />)}
            </tr>
          ))}
      </tbody>
    </table>
  );
};
